import { useLang } from "../i18n";
import { Zap } from "./common";

export default function Marquee() {
    const { t } = useLang();
    const items = t.marquee;

    return (
        <div className="relative border-y border-volt/15 bg-deep py-5 overflow-hidden">
            <div className="marquee-track">
                {[0, 1].map((copy) => (
                    <div key={copy} className="flex items-center shrink-0" aria-hidden={copy === 1}>
                        {items.map((item, i) => (
                            <span key={`${copy}-${i}`} className="flex items-center shrink-0">
                                <span
                                    className={`font-display font-bold text-lg md:text-2xl tracking-wide whitespace-nowrap px-6 ${
                                        i % 2 === 0 ? "text-white" : "text-outline"
                                    }`}
                                >
                                    {item}
                                </span>
                                <Zap className="w-4 h-4 text-volt shrink-0" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
